import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

import {
  SelectComponent,
  CustomDropdownIndicator,
  CustomPlaceholder,
  SearchIcon,
} from './styles'

import 'material-icons/iconfont/outlined.css'

const Select = ({
  value,
  onChange,
  options,
  disabled,
  isSearchable,
  borderColor,
  defaultValue,
  height,
  formatOptionLabel,
  formatGroupLabel,
  isMulti,
  closeMenuOnSelect,
  placeholder,
  onMenuOpen,
  onMenuClose,
  placeholderStyle,
  onMenuScrollToBottom,
  style
}) => (
  <SelectComponent
    classNamePrefix="Select"
    value={value}
    height={height}
    onChange={onChange}
    options={options}
    isSearchable={isSearchable}
    menuPlacement="auto"
    defaultValue={defaultValue && defaultValue}
    style={style}
    menuPosition="fixed"
    borderColor={!disabled ? (borderColor || colors.primary) : ''}
    isDisabled={disabled}
    placeholderStyle={placeholderStyle}
    formatOptionLabel={formatOptionLabel}
    formatGroupLabel={formatGroupLabel}
    isMulti={isMulti}
    onMenuOpen={onMenuOpen}
    onMenuClose={onMenuClose}
    onMenuScrollToBottom={onMenuScrollToBottom}
    placeholder={
      placeholder && (
        <CustomPlaceholder
          color={placeholderStyle && placeholderStyle.style.color}
        >
          {placeholderStyle && placeholderStyle.withSearchIcon && (
            <SearchIcon className="material-icons-outlined">search</SearchIcon>
          )}
          <span>{placeholder}</span>
        </CustomPlaceholder>
      )
    }
    closeMenuOnSelect={closeMenuOnSelect}
    components={{
      DropdownIndicator: () => (
        <CustomDropdownIndicator>
          {disabled ? (
            <span className="material-symbols-outlined">block</span>
          ) : (
            <span className="material-symbols-outlined">expand_more</span>
          )}
        </CustomDropdownIndicator>
      ),
    }}
  />
)

Select.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  disabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  borderColor: PropTypes.string,
  defaultValue: PropTypes.object,
  height: PropTypes.number,
  formatOptionLabel: PropTypes.func,
  formatGroupLabel: PropTypes.func,
  isMulti: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  placeholderStyle: PropTypes.object,
  onMenuScrollToBottom: PropTypes.func,
  style: PropTypes.shape({
    option: PropTypes.shape({
      backgroundColor: PropTypes.string,
      color: PropTypes.string,
    }),
  }),
}

Select.defaultProps = {
  value: {},
  options: [],
  disabled: false,
  style: {},
  isSearchable: false,
  borderColor: 'orange',
  defaultValue: {},
  height: 40,
  formatOptionLabel: null,
  formatGroupLabel: null,
  isMulti: false,
  closeMenuOnSelect: true,
  placeholder: null,
  onMenuOpen: null,
  onMenuClose: null,
  placeholderStyle: null,
  onMenuScrollToBottom: null
}

export default Select
